import { CustomFieldsTranslationCounter } from '@recruitee/custom-fields-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<CustomFieldsTranslationCounter>()('CustomFieldsTranslationCounters', {
    idSelector: item => item.code,
  });

const CustomFieldsTranslationCountersActions = {
  fetchCollection: actions.fetchCollection,
  fetchCollectionSuccess: actions.fetchCollectionSuccess,
  fetchCollectionFailed: actions.fetchCollectionFailed,
};

export {
  selectors as CustomFieldsTranslationCountersSelectors,
  CustomFieldsTranslationCountersActions,
  reducer as CustomFieldsTranslationCountersReducer,
  namespace as CustomFieldsTranslationCountersNamespace,
};
